import { useContext, useId, useState } from 'preact/hooks';
import { ComponentChildren } from 'preact';
import { ClassNameArray, classNames, getEventChecked } from '../lib/util.js';
import { Maybe } from '../../common/data.js';
import { isSome } from '../../common/util.js';
import { SiteContext } from '../context.js';


export function Checkbox({ label, id, onChange = () => undefined, disabled, checked = false, classes = [], radio, name, title }: {
	label: Maybe<string | ComponentChildren>;
	id?: string;
	onChange?: (val: boolean) => void | Maybe<Promise<any>>;
	disabled?: boolean;
	checked?: boolean;
	classes?: ClassNameArray,
	radio?: boolean;
	name?: string;
	title?: Maybe<string>;
}) {

	id ||= useId();
	disabled ||= useContext(SiteContext).isServerSide.peek();
	
	const [changing, setChanging] = useState<Maybe<boolean>>(null);
	
	const handleCheckboxClick = (e: Event) => {
		const value = getEventChecked(e);
		const res = onChange(value);
		if (res && 'finally' in res) {
			setChanging(value);
			res.finally(() => setChanging(null));
		}
	};
	
	return <div class={classNames(
		'checkbox',
		radio && '--radio',
		isSome(changing) && '--changing',
		checked && '--checked',
		...classes,
	)} title={title || undefined}>
		<input
			type={radio ? 'radio' : 'checkbox'}
			name={name}
			class="checkbox__input"
			disabled={disabled}
			checked={changing ?? checked}
			id={id}
			onChange={handleCheckboxClick}
		/>
		<label for={id} class="checkbox__label">
			<span className="checkbox__visual" />
			{isSome(label) && <span className="checkbox__text">{label}</span>}
		</label>
	</div>;
	
}
